import { RandomSampleConsensus } from "../utils/ransac";
import { SampleConsensusModelPlane } from "../utils/sac_model_plane.js";;
export class PointCloudProcessor {

  compute(input, maxIterations = 1000, threshold = 0.05, negative = false) {
    // Convert data to PointCloud format
    // const xyz = convertPCLPointCloud2ToPointCloud(input);

    console.log("Computing...");

    // Timer start
    const startTime = Date.now();
    const sampleSize = 3;

    // Refine the plane indices
    const model = new SampleConsensusModelPlane(input, sampleSize);
    const sac = new RandomSampleConsensus(model, threshold);
    sac.setMaxIterations(maxIterations);

    const res = sac.computeModel();
    let inliers = [];
    let coefficients = [];

    if (res) {
      inliers = sac.getInliers();
      coefficients = sac.getModelCoefficients();
      console.info(
        `after computeModel Model coefficients: [${coefficients[0]}, ${coefficients[1]}, ${coefficients[2]}, ${coefficients[3]}]`
      );
    }

    if (!res || inliers.length === 0) {
      console.error("No planar model found. Relax thresholds and continue.");
      return [];
    }

    sac.refineModel(2, 50);
    inliers = sac.getInliers();
    coefficients = sac.getModelCoefficients();

    console.info(
      `[done, ${(Date.now() - startTime)} ms, plane has: ${inliers.length} points]`
    );

    console.info(
      `after refineModel Model coefficients: [${coefficients[0]}, ${coefficients[1]}, ${coefficients[2]}, ${coefficients[3]}]`
    );
    return coefficients;
    // If `negative` flag is true, return the outliers with cluster segmentation
    // if (negative) {
    //   const everythingButThePlane = [];
    //   const indicesFullset = Array.from({ length: input.size }, (_, i) => i);
    //   inliers.sort((a, b) => a - b);

    //   everythingButThePlane.push(
    //     ...indicesFullset.filter((index) => !inliers.includes(index))
    //   );

    //   // Extract largest cluster minus the plane
    //   const clusterIndices = [];
    //   const ec = new EuclideanClusterExtraction();
    //   ec.setClusterTolerance(0.02); // 2cm
    //   ec.setMinClusterSize(100);
    //   ec.setInputCloud(xyz);
    //   ec.setIndices(everythingButThePlane);
    //   ec.extract(clusterIndices);

    //   // Convert data back
    //   // copyPointCloud(input, clusterIndices[0].indices, output);
    // } else {
    //   // Convert data back
    //   // copyPointCloud(input, inliers, output);
    // }
  }
}
